import React from 'react';

import { useAppContext } from '@/context';
import Container from '../Container';

import { getPreferredLocale } from '../../utils/locale';
import LDTHeader from './LDTHeader';
import PartnerHeader from './PartnerHeader';

import {
  container,
  headerStyle,
  localHeaderStyle,
  stagingHeaderStyle,
} from './styles.module.css';

/**
 * Header presentational component.
 */
const getHeaderClass = (env) => {
  switch (env) {
    case 'development': {
      return localHeaderStyle;
    }
    case 'staging': {
      return stagingHeaderStyle;
    }
    default: {
      return headerStyle;
    }
  }
};

function Header(props) {
  const { canUsePartnerTheme, partnerSession } = props;
  const { LDT_ENV, USER_SELECTED_LOCALE } = useAppContext();
  /*
     This is for case where Header is rendered outside <Layout/> component,
     and we don't know selectedLocale
     */
  const selectedLocale =
    props.selectedLocale ||
    getPreferredLocale({
      USER_SELECTED_LOCALE,
    });

  const HeaderComponent =
    canUsePartnerTheme && partnerSession ? PartnerHeader : LDTHeader;

  return (
    <header className={getHeaderClass(LDT_ENV)} role="banner">
      <Container className={container}>
        <HeaderComponent
          {...props}
          selectedLocale={selectedLocale}
          userSelectedLocale={USER_SELECTED_LOCALE}
        />
      </Container>
    </header>
  );
}

Header.defaultProps = {
  canUsePartnerTheme: false,
};

export default Header;
